import {
  Alert,
  Autocomplete,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import TitleActionsContainer from "../../widgets/TitleActionsContainer";
import PageTitle from "../../widgets/PageTitle";
import SearchIcon from "@mui/icons-material/Search";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { debounce } from "lodash";
import SimpleYesNoDialog from "../../widgets/SimpleYesNoDialog";
import CustomCircularP from "../../widgets/CustomCircularP";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import { getErrorResponse, getHeader, toastError } from "../../utils/util";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import useApiEp from "../../hooks/useApiEp";
import MuPb from "../../widgets/MuPb";
import DataTable from "../../widgets/DataTable";
import IconMenu from "../../widgets/IconMenu";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { GlassButton } from "../../themes/UiElements";
const ContactsList = () => {
  const [phoneQ, setPhoneQ] = useState("");
  const [groupName, setGroupName] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [deleting, setDeleting] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { data, isLoading, isError, error, refetch } = useApiEp(
    `/user/get-contacts-group?searchphoneNumber=${phoneQ}&group=${groupName}`
  );
  const { data: contactList, isLoading: loadingList } =
    useApiEp(`/user/group-list`);
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [toDelete, setToDelete] = useState("");
  const debouncedSearch = useCallback(
    debounce((value) => {
      setPhoneQ(value);
    }, 500),
    []
  );
  // useEffect(() => {
  //   console.log(groupName);
  // }, [groupName]);
  const handleSearchChange = (value) => {
    debouncedSearch(value);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleAction = useCallback((action, id) => {
    switch (action) {
      case "view":
        navigate(`/home/configurations/contacts/${id}/contact-detail`);
        break;
      case "edit":
        break;
      case "delete":
        setToDelete(id);
        setShowDelete(true);
        break;
      default:
        console.warn("unknown action", id);
    }
  }, []);
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }
  return (
    <Container sx={{ mt: 3 }}>
      <CustomCircularP show={isLoading || deleting} />
      <TitleActionsContainer>
        <PageTitle>Contacts List</PageTitle>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          sx={{
            width: { xs: "100%", sm: "auto" },
            mt: { xs: 1, sm: 0 },
          }}
        >
          <Autocomplete
            size="small"
            loading={loadingList}
            sx={{ minWidth: 164 }}
            value={groupName}
            onChange={(event, newV) => {
              if (!newV) {
                setGroupName("");
                return;
              }
              setGroupName(newV);
            }}
            options={contactList || []}
            renderInput={(params) => (
              <TextField {...params} label="Group Name" />
            )}
          />
          <TextField
            sx={{ minWidth: 200 }}
            size="small"
            onChange={(e) => handleSearchChange(e.target.value)}
            placeholder="Search by Phone"
            InputProps={{ startAdornment: <SearchIcon fontSize="small" /> }}
          />

          <GlassButton
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
              //navigate(`/home/add-contact`);
            }}
            variant="outlined"
            startIcon={<AddOutlinedIcon />}
          >
            Add
          </GlassButton>
          <IconMenu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            menuItems={[
              {
                label: "Create Contact Group",
                icon: <GroupAddIcon />,
                onClick: () => {
                  handleMenuClose();
                  navigate(`/home/add-contact`);
                },
              },
              {
                label: "Add Contact List to Group",
                icon: <PlaylistAddIcon />,
                onClick: () => {
                  handleMenuClose();
                  console.log("Add to group clicked");
                  navigate(`/home/add-contact-list`);
                },
              },
            ]}
          />
        </Stack>
      </TitleActionsContainer>
      <SimpleYesNoDialog
        show={showDelete}
        setShow={setShowDelete}
        title={"Please confirm!"}
        message={"Are you sure you want to delete this item?"}
        onYes={async () => {
          try {
            setDeleting(true);
            setShowDelete(false);
            const response = await axios.delete(
              `${API_ENDPOINT}/user/delete-contact/${toDelete}`,
              getHeader()
            );
            toast.success(response.data.message);
            refetch();
          } catch (error) {
            toastError(error);
          } finally {
            setDeleting(false);
          }
        }}
      />
      <DataTable
        sx={{ mb: 1 }}
        columns={[
          {
            id: "serial",
            label: "S.No.",
            render: (_v, _row, idx) => (page - 1) * limit + idx + 1,
          },
          { id: "groupName", label: "Group" },
          { id: "phoneNumber", label: "Phone" },
          { id: "Name", label: "Name" },
          {
            id: "createdOn",
            label: "Created On",
            render: (v) =>
              new Date(v).toLocaleString("en-IN", {
                dateStyle: "medium",
              }),
          },
        ]}
        actions={["view", "delete"]}
        rows={data?.data ?? []}
        page={page}
        limit={limit}
        totalPages={data?.totalPages ?? 1}
        onPageChange={setPage}
        onAction={handleAction}
      />
    </Container>
  );
};

export default ContactsList;
